const BASE_ROUTES = {
  API_NAVIGATOR: "/api-lab",
  GOVERNANCE_NAVIGATOR: "/governance-navigator",
  API_APPLICATIONS: "/api-studio",
  DEVELOPER_STUDIO: "/developer-studio",
  API_RULES: "/api-rules",
  API_DATA_HUB: "/api-datahub",
  WORKFLOW: "/workflow-navigator",
  API_HUB: "/documentation-portal",
  SETTINGS: "/company-settings",
  EXISTING_APP: "/existing-app",
  E2E_TESTING: "/api-lab/api-e2e",
  SERVICE_PULSE: "/service-pulse",
} as const;

export const PARENT_ROUTE_PREFIX = "defect-tracker";
export const ROUTES = {
  HOME: "/",
  TOOLS: "/tools",
  DOWNLOAD_PAGE: "/download-app",
  SIGN_IN: "/login",
  SIGN_UP: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  CONFIRM_USER: "/confirm-user",
  PROJECTS: `/${PARENT_ROUTE_PREFIX}/projects`,
  MY_TASKS: `/${PARENT_ROUTE_PREFIX}/my-tasks`,
  DEFECT_TRACKER_SETTINGS: `/${PARENT_ROUTE_PREFIX}/settings`,
  // Legacy route - will redirect to dashboard
  PROJECT_BOARD: `/${PARENT_ROUTE_PREFIX}/projects/:id/task-board`,
  // New route-based navigation
  PROJECT_BASE: `/${PARENT_ROUTE_PREFIX}/projects/:id`,
  PROJECT_DASHBOARD: `/${PARENT_ROUTE_PREFIX}/projects/:id/dashboard`,
  PROJECT_FEEDBACK: `/${PARENT_ROUTE_PREFIX}/projects/:id/feedback`,
  PROJECT_FEEDBACK_CONFIG: `/${PARENT_ROUTE_PREFIX}/projects/:id/feedback-config`,
  PROJECT_BACKLOG: `/${PARENT_ROUTE_PREFIX}/projects/:id/backlog`,
  PROJECT_SPRINTS: `/${PARENT_ROUTE_PREFIX}/projects/:id/sprints`,
  PROJECT_SPRINT: `/${PARENT_ROUTE_PREFIX}/projects/:id/sprints/:sprintId`,
  PROJECT_SETTINGS: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings`,
  PROJECT_SETTINGS_MEMBERS: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings/members`,
  PROJECT_SETTINGS_TAGS: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings/tags`,
  PROJECT_SETTINGS_INTEGRATIONS: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings/integrations`,
  PROJECT_SETTINGS_APPEARANCE: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings/appearance`,
  PROJECT_SETTINGS_SNIFFER_AUTOBUG: `/${PARENT_ROUTE_PREFIX}/projects/:id/settings/sniffer-autobug`,
  PROJECT_RECURRING_TASKS: `/${PARENT_ROUTE_PREFIX}/projects/:id/recurring-tasks`,
  PROJECT_RETROSPECTIVES: `/${PARENT_ROUTE_PREFIX}/projects/:id/retrospectives`,
  PROJECT_SYSTEM_BUGS: `/${PARENT_ROUTE_PREFIX}/projects/:id/system-bugs`,
  PROJECT_SYSTEM_BUGS_DETAIL: `/${PARENT_ROUTE_PREFIX}/projects/:id/system-bugs/:bugId`,
  PROJECT_APPLICATION_LIST: `/${PARENT_ROUTE_PREFIX}/projects/:id/applications`,
  // Public routes (no authentication required)
  PUBLIC_BUG: `/public/bug/:bugId`,
  HTML_EDITOR: "/html-editor",
  AUTH_CALLBACK: "/auth-callback",
  COMPANY_SETTINGS: `/company-settings`,
  ...BASE_ROUTES,
  API_NAVIGATOR_ALL: `${BASE_ROUTES.API_NAVIGATOR}/*`,
  GOVERNANCE_NAVIGATOR_ALL: `${BASE_ROUTES.GOVERNANCE_NAVIGATOR}/*`,
  DEVELOPER_STUDIO_ALL: `${BASE_ROUTES.DEVELOPER_STUDIO}/*`,
  API_RULES_ALL: `${BASE_ROUTES.API_RULES}/*`,
  API_DATA_HUB_ALL: `${BASE_ROUTES.API_DATA_HUB}/*`,
  WORKFLOW_ALL: `${BASE_ROUTES.WORKFLOW}/*`,
  SETTINGS_ALL: `${BASE_ROUTES.SETTINGS}/*`,
  EXISTING_APP_ALL: `${BASE_ROUTES.EXISTING_APP}/*`,
  API_APPLICATIONS_ALL: `${BASE_ROUTES.API_APPLICATIONS}/*`,
  API_HUB_ALL: `${BASE_ROUTES.API_HUB}/*`,
  E2E_TESTING_ALL: `${BASE_ROUTES.E2E_TESTING}/*`,
  SERVICE_PULSE_ALL: `${BASE_ROUTES.SERVICE_PULSE}/*`,
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
